export default __webpack_public_path__ + "static/media/icon_medal.76bf1fc8.svg";